<template>
  <div class="user-profile">
    <div class="profile-info">
      <span>{{userName}}</span>
    </div>
    <!-- <div class="profile-info">
      <span>{{userEmail}}</span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    userName: String,
    userEmail: String
  }
}
</script>

<style scoped>
</style>
